import { createFileRoute } from '@tanstack/react-router'
import { RendersHome } from '~/components/renders/renders-home'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/renders/')({
  component: RendersHome,
})
